export default "__VITE_ASSET__Cdg$kExD__"